define('GameDayCore/GDModel/ValueObjects/Gamecenter/WrapupArticleList',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(WrapupArticleList);

	function WrapupArticleList($data) {
		var vo = VO.ensureVO(this, WrapupArticleList),
			data = $data;

			vo.articles = data.list;
	}

	return WrapupArticleList;
});
